import client from "./client";
export function authLogin(email, password) {
  const body = {
    email: email,
    password: password,
  };

  return client.post("/api/auth/login/", body).then((res) => res.data);
}

export function authLogout() {
  return client.post("/api/auth/logout/").then((res) => res.data);
}

export function authRefresh() {
  return client.post("/api/auth/token/refresh/").then((res) => res.data);
}

export function authVerify() {
  return client.post("/api/auth/token/verify/").then((res) => res.data);
}

export function changePassword(body) {
  return client
    .post("/api/auth/password/change/", body)
    .then((res) => res.data);
}
export function passwordResetMail(body) {
  return client
    .post("/api/auth/password/reset_mail/", body)
    .then((res) => res.data);
}

export function verifyResetToken(token) {
  return client
    .post("/api/auth/verify_reset_token/", { token })
    .then((res) => res.data);
}

export function passwordReset(password, token) {
  const bodyForPasswordReset = {
    password: password,
    token: token,
  };
  return client
    .post("/api/auth/password_reset/", bodyForPasswordReset)
    .then((res) => res.data);
}
